import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import GlobalInject from 'themes/global-inject'
import moment from 'moment'
import 'moment-timezone'
import 'moment/locale/da.js'
import Layout from '../layouts'
import '@bet25/ui/dist/ui.css'

window.onload = () => {
    moment.locale('da')
}

const App = () => (
    <BrowserRouter>
        <GlobalInject />
        <Layout />
    </BrowserRouter>
)

export default App
